import React, { useMemo } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setFareOption } from '../../../../../../../../redux/fetchActions/legadoPage/faresApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetFare() {
  const dispatch = useDispatch();
  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );
  const profileUserState = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );

  function setFare(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setFareOption(value));
  }

  const isNivelTwo = useMemo(() => {
    if (
      profileUserState.nivel === 2 &&
      (faresFilterState.partner === 'global' ||
        faresFilterState.partner === '1')
    ) {
      return (
        <>
          <option key={4} value="tib">
            {5} - TIB
          </option>
          <option key={5} value="slb">
            {6} - SLB
          </option>
        </>
      );
    }
    return <></>;
  }, [profileUserState.nivel, faresFilterState.partner]);

  return (
    <Wrapper.Default flexDirection="row" isActive>
      <span>Tarifa:</span>
      <Form.Control
        as="select"
        style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
        value={faresFilterState.fare}
        onChange={(event) => setFare(event)}>
        <option key={0} value="receita">
          {1} - Receita
        </option>
        <option key={1} value="boleto">
          {2} - Boleto
        </option>
        <option key={2} value="mensalidade">
          {3} - Manutenção de Conta
        </option>
        <option key={3} value="ted">
          {4} - TED
        </option>
        {isNivelTwo}
        <option key={7} value="pix">
          {7} - PIX
        </option>
        <option key={8} value="cripto">
          {8} - Cripto
        </option>
        <option key={9} value="cartao">
          {9} - Cartão
        </option>
        <option key={10} value="domicilio">
          {10} - Domicilio
        </option>
        <option key={11} value="tev">
          {11} - TEV
        </option>
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetFare;
